import React, { Component } from 'react';
import styled from 'styled-components';
import queryString from 'query-string';
import { Tap } from '../dooh-react-utils';
import preloader from '../preload';
import ctaVideo from '../assets/bubble.webm';
import thanks from '../assets/thanks.png';
import header from '../assets/header.png';

let qs = queryString.parse(window.location.search);

const Wrap = styled(Tap)`
  background-color: #ffdc46;

  video,
  img {
    position: absolute;
    top: 0;
    left: 0;
  }

  img {
    background: url('${preloader.get(header)}') no-repeat 50% 50px;
  }

  a {
    background-color: #ffdc46;
    position: absolute;
    top: 800px;
    width: 100%;
    text-align: center;
  }
`;

class Screen extends Component {
  render() {
    let onTap = () => {
      if (qs.tracking != null && qs.tracking.startsWith('web')) {
        let url = `https://mentalnahigijena.hr/?utm_source=${
          qs.tracking
        }&utm_medium=g2d&utm_campaign=kviz`;
        if (window.parent) {
          window.parent.location.replace(url);
        } else {
          window.location.replace(url);
        }
      } else {
        this.props.gotoNextScreen();
      }
    };
    return (
      <Wrap onTap={onTap}>
        <video id="vid" src={preloader.get(ctaVideo)} muted autoPlay loop />
        <img src={preloader.get(thanks)} alt="" />
      </Wrap>
    );
  }
}

export default Screen;
